import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import {
    setLoadingPage,
    setErrorMessage,
    setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import MessageReport from "../assetReport/messageReport";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import { Button } from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import queryString from "query-string";
import Select from "react-select";

class AssetReportDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assetPlaceholder: "Select Asset",
            dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
            calendarSelect: true,
            calendarSelect2: false,
            dataPlaceholder2: "Select end date",
            calendarStartDate: new Date(),
            calendarEndDate: new Date(),
            assetShow: false,
            groupTabHighlight: true,
            assetTabHighlight: false,
            groupTabHeading: true,
            assetTabHeading: true,
            groupCustomerName: "",
            groupGeneralName: "",
            assetCustomerName: "",
            assetGeneralName: "",
            ReportDate: moment().format("YYYY-MM-DD"),
            globalDate: new Date(),
            endDate: new Date(),
            calendarShow: false,
            calendarShow2: false,
            groupDetails: [],
            groupId: "",
            AssetList: [],
            assetId: "",
            timezoneTz: "",
            reportDetails: [],
            assetLoader: true,
            reportLoader: false,
            errorLoader: false,
            generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
            assetSelectionBoolean: false,
            isLoading: false,
            loadedReportParams: null
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    async componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        if (values.assetId) {
            console.log("AssetId from Realtime ", values.assetId);
            console.log("Assetname from Realtime ", values.EndDate);
            console.log("assetDate from Realtime ", values.SearchDate);
            if (values.SearchDate) {
                await this.setState({
                    dataPlaceholder: moment(values.SearchDate).format(
                        "dddd Do MMMM, YYYY"
                    ),
                    ReportDate: values.SearchDate,
                    calendarSelect: true,
                });
            }
            if (values.EndDate) {
                await this.setState({
                    dataPlaceholder2: moment(values.EndDate).format(
                        "dddd Do MMMM, YYYY"
                    ),
                    endDate: values.EndDate,
                });
            }
            await this.setState({
                assetPlaceholder: values.assetName,
                assetCustomerName: values.assetName,
                assetId: values.assetId,
            });
            this.handleCreateReport();
        }
        try {
            let GroupList = await axios.post(
                `${apiHost}/api/Notification/AllGroupForNotification`,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );

            this.setState({ groupDetails: GroupList.data });
            console.log("group details", GroupList.data);
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ calendarShow: false, calendarShow2: false });
        }
    }

    getAssets = async (groupId) => {
        try {
            let AssetList = await axios.get(
                `${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );

            if (AssetList.status === 200) {
                this.setState({ isLoading: false, AssetList: AssetList.data.paggedlist, assetLoader: false });
            }
            else {
                this.setState({ isLoading: true });
            }

            // this.setState({
            //   AssetList: AssetList.data.paggedlist,
            //   assetLoader: false,
            // });
            console.log("group details", AssetList.data.paggedlist);
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    handleGroupSelection = (selectedGroup) => {
        if (!selectedGroup) {
            this.groupId = "";
            this.setState({
                groupId: "",
                groupCustomerName: "",
                groupGeneralName: "",
                assetCustomerName: "",
                assetGeneralName: "",
                assetPlaceholder: "Select Asset",
                assetId: "",
                AssetList: [],
                assetLoader: false,
            });
            return;
        }

        const group = selectedGroup.data;
        this.groupId = group.groupId;
        this.setState({
            groupId: group.groupId,
            groupCustomerName: group.customername,
            groupGeneralName: group.groupName,
            assetCustomerName: "",
            assetGeneralName: "",
            assetPlaceholder: "Select Asset",
            assetId: "",
            AssetList: [],
            assetLoader: true,
        });
        this.getAssets(group.groupId);
    };
    handleAssetSelection = (selectedAsset) => {
        if (!selectedAsset) {
            this.setState({
                assetId: "",
                assetCustomerName: "",
                assetGeneralName: "",
                assetPlaceholder: "Select Asset",
            });
            return;
        }

        const asset = selectedAsset.data;
        this.setState({
            assetId: asset.assetId,
            assetCustomerName: asset.name,
            assetGeneralName: asset.customerName,
            assetPlaceholder: asset.name,
        });
    };
    toggleGroupTable = () => {
        let assetClosingBoolean = !this.state.groupTabHighlight;
        this.setState({
            groupTabHighlight: !this.state.groupTabHighlight,
        });

        if (assetClosingBoolean) {
            this.setState({
                assetTabHighlight: false,
            });
        }
    };
    toggleAssetTable = () => {
        let groupClosingBoolean = !this.state.assetTabHighlight;

        this.setState({
            assetTabHighlight: !this.state.assetTabHighlight,
        });
        if (groupClosingBoolean) {
            this.setState({
                groupTabHighlight: false,
            });
        }
    };
    truckFunction = () => {
        // alert("truck function clicked");
        this.setState({
            assetShow: !this.state.assetShow,
        });
    };
    calendarFunction = () => {
        this.setState({
            calendarShow: !this.state.calendarShow,
        });
    };
    onChangeDate = (date) => {
        console.log("daateeeee", date);
        console.log("clicked date mvtl", moment(date).format("YYYY-MM-DD"));
        this.setState({
            calendarSelect: true,
            calendarStartDate: date,
            globalDate: date,
            ReportDate: moment(date).format("YYYY-MM-DD"),
            dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
            calendarShow: false,
        });
    };
    calendarFunction2 = () => {
        if (this.state.globalDate != "") {
            this.setState({
                calendarShow2: !this.state.calendarShow2,
            });
        } else {
            alert("select start date");
        }
    };
    onChangeDate2 = (date) => {
        console.log("end date", date);
        this.setState({
            calendarSelect2: true,
            calendarEndDate: date,
            endDate: moment(date).format("YYYY-MM-DD"),
            dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
            calendarShow2: false,
        });
    };
    handleTimezoneTz = (e) => {
        console.log(this.state.timezoneTz);
        this.setState({
            timezoneTz: e.target.value,
        });
    };
    handleSelectTimezoneTz = (eventKey) => {
        console.log(eventKey);
        this.setState({
            timezoneTz: eventKey,
        });
    };
    handleWindow = () => {
        this.props.setHeaderVisibleAction(!this.props.headerHide);
    };
    handleCreateReport = async () => {
        const selectedTimeZone = localStorage.getItem("timeZoneID") || "Australia/Melbourne";
        this.setState({
            assetSelectionBoolean: true,
            reportLoader: true,
            generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
            loadedReportParams: {
                assetId: this.state.assetId,
                groupId: this.state.groupId,
                reportDate: this.state.ReportDate,
                timezoneTz: selectedTimeZone,
            },
            // generatedDate:moment().format("DD-MMM hh:mm a")
        });

        try {
            console.log(`${apiHost}/api/Report/AssetReport`);
            let ReportDetails = await axios.post(
                `${apiHost}/api/Report/AssetReport`,
                {
                    AssetId: this.state.assetId,
                    SearchDate: this.state.ReportDate,
                    TimezoneTz: selectedTimeZone,
                    UseFiltering: true,
                    //EndDate: this.state.endDate,
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );
            this.setState({
                reportLoader: false,
                errorLoader: false,
            });

            console.log("ReportDetails", ReportDetails);
            this.setState({ reportDetails: ReportDetails.data });
        } catch (e) {
            this.setState({ errorLoader: true, reportLoader: false });
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    render() {
        const selectStyles = {
            control: (base, state) => ({
                ...base,
                minHeight: 44,
                backgroundColor: "#f8fafc",
                borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
                borderRadius: 8,
                boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
                "&:hover": {
                    borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
                },
            }),
            indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "#dbe4ef",
            }),
            option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
                color: state.isSelected ? "#fff" : "#26354f",
                fontSize: 13,
            }),
            placeholder: (base) => ({
                ...base,
                color: "#7e8da1",
            }),
            singleValue: (base) => ({
                ...base,
                color: "#17233c",
                fontWeight: 700,
            }),
            menu: (base) => ({
                ...base,
                zIndex: 200,
                borderRadius: 8,
                overflow: "hidden",
            }),
        };
        const groupOptions = this.state.groupDetails.map((group) => ({
            value: group.groupId,
            label: `${group.customername} - ${group.groupName}`,
            data: group,
        }));
        const selectedGroupOption =
            groupOptions.find((option) => option.value == this.state.groupId) || null;
        const assetOptions = this.state.AssetList.map((asset) => ({
            value: asset.assetId,
            label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
            data: asset,
        }));
        const selectedAssetOption =
            assetOptions.find((option) => option.value == this.state.assetId) ||
            (this.state.assetId
                ? {
                    value: this.state.assetId,
                    label: this.state.assetPlaceholder,
                    data: {
                        assetId: this.state.assetId,
                        name: this.state.assetPlaceholder,
                        customerName: this.state.assetGeneralName,
                    },
                }
                : null);
        const selectedTimeZone = localStorage.getItem("timeZoneID");
        const canCreateReport = !!(
            this.state.assetCustomerName != "" &&
            this.state.calendarSelect
        );
        const loadedReportParams = this.state.loadedReportParams;
        const hasPendingReportChanges = !!(
            loadedReportParams &&
            canCreateReport &&
            (
                loadedReportParams.assetId !== this.state.assetId ||
                (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
                loadedReportParams.reportDate !== this.state.ReportDate ||
                (loadedReportParams.timezoneTz || "") !== (selectedTimeZone || "")
            )
        );

        const calendarReport = this.state.calendarShow ? (
            <div
                className="ParentCalender"
                ref={this.setWrapperRef}
                style={{ position: "relative", zIndex: 100 }}
            >
                <div className="CalendarContainer" style={{ position: "absolute" }}>
                    <Calendar
                        maxDate={new Date()}
                        //  minDate={moment(this.state.globalDate[0]).subtract(3, 'months').toDate()}
                        onChange={this.onChangeDate}
                        value={this.state.calendarStartDate}
                    />
                </div>
            </div>
        ) : (
            ""
        );
        return (
            <Layout>
                <Helmet>
                    <title>Asset Log</title>
                </Helmet>
                <div className="contentBody">
                    <div
                        className={
                            !this.props.headerHide
                                ? `contentWrapper contentWrapperSmoothRelease report-modern-page asset-log-report-page`
                                : `contentWrapper contentWrapperSmooth report-modern-page asset-log-report-page`
                        }
                    >
                        <div className="reportHeaderTile">
                            <div className="headingContainer report-modern-header">
                                <div>
                                    <h2 className="mainHeading">Asset Log</h2>
                                    <p>Review raw device message activity for a selected asset.</p>
                                </div>
                                <i
                                    className={
                                        this.props.headerHide
                                            ? `fa fa-window-restore`
                                            : `fa fa-window-maximize`
                                    }
                                    onClick={this.handleWindow}
                                />
                            </div>
                            <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                                <div className="inputElement reportPickerField">
                                    <label>Group</label>
                                    <Select
                                        value={selectedGroupOption}
                                        options={groupOptions}
                                        styles={selectStyles}
                                        onChange={this.handleGroupSelection}
                                        isClearable
                                        isSearchable
                                        placeholder="Search group"
                                        noOptionsMessage={() => "No groups found"}
                                    />
                                </div>
                                <div className="inputElement reportPickerField reportPickerFieldWide">
                                    <label>Asset</label>
                                    <Select
                                        value={selectedAssetOption}
                                        options={assetOptions}
                                        styles={selectStyles}
                                        onChange={this.handleAssetSelection}
                                        isClearable
                                        isSearchable
                                        isDisabled={!this.state.groupId && !this.state.assetId}
                                        isLoading={this.state.assetLoader && this.state.groupId != ""}
                                        placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                                        noOptionsMessage={() => "No assets found"}
                                    />
                                </div>
                                <div className="inputElement reportPickerField">
                                    <label>Date</label>
                                    <ReportButtonGroup
                                        function={this.calendarFunction}
                                        dropDown={calendarReport}
                                        placeholder={this.state.dataPlaceholder}
                                        icon="fa-calendar"
                                    />
                                </div>
                                <div className="inputElement reportPickerActions">
                                    {canCreateReport ? (
                                            <Button
                                                className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                                                variant="primary"
                                                onClick={this.handleCreateReport}
                                                size="sm"
                                            >
                                                <i className="fa fa-bar-chart"></i>
                                                Create Report
                                            </Button>
                                        ) : (
                                            <Button
                                                className="reportPickerCreateButton"
                                                variant="primary"
                                                onClick={this.handleCreateReport}
                                                size="sm"
                                                disabled
                                            >
                                                <i className="fa fa-bar-chart"></i>
                                                Create Report
                                            </Button>
                                        )}
                                </div>
                            </div>
                        </div>
                        <TimeZoneConvert />
                        {this.state.assetSelectionBoolean ? (
                            <div className="reportBody">
                                {this.state.reportLoader ? (
                                    <div className="loaderLine">
                                        <br />{" "}
                                        <GridLoader
                                            size={7}
                                            color={"#222222"}
                                            loading={this.state.reportLoader}
                                        />
                                        <h1> &nbsp;Generating Report</h1>
                                        <br />
                                    </div>
                                ) : this.state.errorLoader ? (
                                    <div className="loaderLine">
                                        <h1>Something Went Wrong...!</h1>
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <MessageReport reportDetails={this.state.reportDetails}
                                            assetCustomerName={this.state.assetPlaceholder}
                                            calendarSelectedDate={this.state.calendarStartDate}
                                            timeZoneID = {selectedTimeZone}
                                        />
                                    </React.Fragment>
                                )}
                            </div>
                        ) : (
                            <AssetInforWarning />
                        )}
                    </div>
                </div>
            </Layout>
        );
    }
}
const mapStateToProps = (state) => ({
    loading: state.loading,
    headerHide: state.headerHide,
    timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage,
    setHeaderVisibleAction: setHeaderVisible,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetReportDetail);
